import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
export default {
  init() {
    $(document).ready(() => {
      $(document).on("click", ".remove-question", event => {
        event.preventDefault();
        const current = $(event.currentTarget);
        const target = current.attr("data-target");
        const toEliminate = $(`.${target}`);
        toEliminate.fadeOut(400, () => {
          toEliminate.remove();
        });
        $("#faq-form").attr("changed", true);
        $(".move-on").addClass("form-finish");
      });
      $(document).on("click", ".dropdown-menu.hide-on-click .dropdown-item", event => {
        $(event.currentTarget).closest(".dropdown-menu").removeClass("show");
      });
      $(document).on("click", "a.add-comment", event => {
        const anchor = $(event.currentTarget);
        const text = anchor.text();
        const doc = anchor.attr("document");
        const documentBox = $(`.${doc}:not(.row)`);
        documentBox.fadeToggle();
        documentBox.animate({
          scrollTop: documentBox.prop("scrollHeight")
        }, 400);
        if (anchor.hasClass("hidden")) anchor.text(text.replace("Show", "Hide"));else anchor.text(text.replace("Hide", "Show"));
        anchor.toggleClass("hidden");
      });
      $(document).on("keypress", ".no-default-submit", event => {
        const currentCode = $.getEventKeyCode(event);
        if (currentCode === 13) event.preventDefault();
      });
      $(document).on("keyup", "input.comment", event => {
        const form = $(event.currentTarget).closest("form").attr("id");
        if (event.keyCode === 13) $(`#${form}`).submit();
      });
      $(document).on("click", ".paper-comment", event => {
        const form = $(event.currentTarget).closest("form").attr("id");
        $(`#${form}`).submit();
      });
      $(document).on("click", ".sidetab", () => {
        const root = $("html");
        root.css("overflow", "auto");
        $("#sidebar").removeClass("show");
      });
      $(document).on("click", ".navbar-toggler", () => {
        const navBar = $("#sidebar");
        const root = $("html");
        if ($(".form-page.finastra").hasClass("in")) $(".finastra-expand-button").click();
        if (root.css("overflow") == "hidden") {
          root.css("overflow", "auto");
        } else {
          root.css("overflow", navBar.hasClass("collapsed") ? "auto" : "hidden");
        }
      });
      $(document).on("click", ".finastra-expand-button", () => {
        const root = $("html");
        const target = $(".form-page.finastra");
        if (target.hasClass("in")) {
          root.css("overflow", "auto");
          $(".form-page.finastra").removeClass("in");
        } else {
          root.css("overflow", "hidden");
          if ($(".navbar-collapse").hasClass("show")) $(".navbar-toggler").click();
          $(".form-page.finastra").addClass("in");
        }
      });
      $(document).on("DOMNodeRemoved", "#preload", ({
        currentTarget
      }) => {
        $(currentTarget).closest(".preload-fix").removeClass("preload-fix");
      });
      $(document).on("show.bs.modal", ".modal.extra-modal", () => $("html, body").css("overflow-y", "hidden"));
      $(document).on("hide.bs.modal", ".modal.extra-modal", () => $("html, body").css("overflow-y", "auto"));
      $(document).on("show.bs.modal", ".modal:not(.extra-modal, .note-modal)", e => {
        const modal = $(e.currentTarget);
        const modalId = modal.attr("id");
        $(`body > #${modalId}`).remove();
        if (modal.hasClass("component-modal")) {
          modal.clone().appendTo("body").addClass("extra-modal").modal();
        } else {
          modal.appendTo("body").addClass("extra-modal").modal();
        }
      });
      $(window).on("optimizedResize", () => {
        const target = $(".scroll-container");
        if (!target.exists()) return;
        target.each((idx, elem) => {
          const currentTarget = $(elem);
          if (Math.ceil(currentTarget.innerWidth()) < currentTarget[0].scrollWidth) currentTarget.addClass("scroll-visible");else currentTarget.removeClass("scroll-visible");
          currentTarget.trigger("scroll");
        });
      });
      $(document).on("hidden.bs.modal", ".modal-page", ({
        currentTarget
      }) => {
        $(currentTarget).remove();
      });
      const handleMaterialInput = input => {
        if (input.val()) {
          input.addClass("form-control-filled");
        } else {
          input.removeClass("form-control-filled");
        }
      };
      $(document).on("materialChanged", ".form-group-material:not(.no-event) :input", ({
        currentTarget
      }) => handleMaterialInput($(currentTarget)));
      $(document).on("input change", ".form-group-material:not(.no-event) :input", ({
        currentTarget
      }) => $(currentTarget).trigger("materialChanged"));
      $(document).on("mousemove keypress", () => {
        $(document).trigger("noidle");
      });
      $(document).on("keydown", "#sidebar", event => {
        var _context;
        const TAB_KEY = 9;
        if (event.which !== TAB_KEY || !_includesInstanceProperty(_context = location.hash).call(_context, "applicationId")) return;
        $("a.property-link").first().focus();
      });
      $(document).on("click", ".reveal-password", ({
        currentTarget
      }) => {
        const eye = $(currentTarget);
        const wrapper = eye.closest(".reveal-password-wrapper");
        const password = _findInstanceProperty(wrapper).call(wrapper, ".password-input");
        const passwordType = password.attr("type");
        const nextPasswordType = passwordType === "password" ? "text" : "password";
        password.attr("type", nextPasswordType);
        eye.toggleClass("text-muted text-primary");
      });
    });
  }
};